export const AuthEvents = {
  signOut: 'SIGN_OUT'
};